import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { ButtonLabel } from '../shared';
import { getSecondaryThemeConfig, SecondaryButtonContainer } from '../styles';
var SecondaryButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      theme = _ref.theme,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      _ref$disableHoverAnim = _ref.disableHoverAnimation,
      disableHoverAnimation = _ref$disableHoverAnim === void 0 ? true : _ref$disableHoverAnim,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "isLoading", "loadingText", "data-test", "type", "theme", "leadingIcon", "trailingIcon", "variant", "disableHoverAnimation"]);

  var componentTheme = useComponentTheme({
    name: 'SecondaryButton',
    theme: getSecondaryThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(SecondaryButtonContainer, _extends({}, buttonProps, {
    isLoading: isLoading,
    size: size,
    "data-test": dataTest ? dataTest : undefined,
    ref: ref,
    type: type,
    customTheme: componentTheme,
    variant: variant,
    disableHoverAnimation: disableHoverAnimation
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    isLoading: isLoading,
    size: size,
    loadingText: loadingText,
    customTheme: componentTheme,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon
  }, children));
});
SecondaryButton.displayName = 'SecondaryButton';
export default SecondaryButton;